// extracted by mini-css-extract-plugin
export var askAiIcon = "_pn-9";
export var container = "_pn-0";
export var groupSeparator = "_pn-a";
export var highlight = "_pn-4";
export var resultIcon = "_pn-5";
export var resultItem = "_pn-7";
export var resultSubtitle = "_pn-3";
export var resultTitle = "_pn-2";
export var resultsList = "_pn-1";
export var searchGroup = "_pn-6";
export var selected = "_pn-8";